/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PreferenceData } from '../model/preferenceData';
import { UpdatePreferencesPayload } from '../model/updatePreferencesPayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EnduserPreferenceService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get preferences of an enduser
     * 
     * @param enduserId Enduser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnduserPreferences(enduserId: string, observe?: 'body', reportProgress?: boolean): Observable<PreferenceData>;
    public getEnduserPreferences(enduserId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PreferenceData>>;
    public getEnduserPreferences(enduserId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PreferenceData>>;
    public getEnduserPreferences(enduserId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enduserId === null || enduserId === undefined) {
            throw new Error('Required parameter enduserId was null or undefined when calling getEnduserPreferences.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PreferenceData>(`${this.basePath}/api/endusers/${encodeURIComponent(String(enduserId))}/preferences`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update preferences of an enduser
     * 
     * @param enduserId Enduser
     * @param payload Preferences to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEnduserPreferences(enduserId: string, payload?: UpdatePreferencesPayload, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateEnduserPreferences(enduserId: string, payload?: UpdatePreferencesPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateEnduserPreferences(enduserId: string, payload?: UpdatePreferencesPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateEnduserPreferences(enduserId: string, payload?: UpdatePreferencesPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (enduserId === null || enduserId === undefined) {
            throw new Error('Required parameter enduserId was null or undefined when calling updateEnduserPreferences.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/endusers/${encodeURIComponent(String(enduserId))}/preferences`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
